// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import User, { processUser } from "./User";
import Util from "PreciateUtil";

export default interface SocialInvite {
    socialInviteId?: string;
    socialId?: string;
    invitedUserId?: string;
    invitedUser?: User;
    didAttend?: boolean;
    dateTimeInvited?: Date;
    error?: string;
}

export function processSocialInvite(value?: SocialInvite): void {
  if (value) {
    value.dateTimeInvited = Util.toDate((value as any).dateTimeInvited);
    processUser(value.invitedUser);
  }
}

export function processSocialInviteArray(array?: SocialInvite[]): void {
  if (array) {
    for (const v of array) {
      processSocialInvite(v);
    }
  }
}
